import { render, staticRenderFns } from "./Encryption.vue?vue&type=template&id=0fc4e288&"
import script from "./Encryption.vue?vue&type=script&lang=js&"
export * from "./Encryption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/admin/Docker/apps2/privacy/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fc4e288')) {
      api.createRecord('0fc4e288', component.options)
    } else {
      api.reload('0fc4e288', component.options)
    }
    module.hot.accept("./Encryption.vue?vue&type=template&id=0fc4e288&", function () {
      api.rerender('0fc4e288', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Encryption.vue"
export default component.exports